import React from 'react';
import { Button, Form } from 'react-bootstrap';
import moment from 'moment-timezone';
import { DownArrowIcon, UpArrowIcon } from "../../../../assets/Svg/SvgImages.jsx";
import CustomInput from "../../../../components/ui/CustomInput/CustomInput.jsx";
import TradeAmountCard from "../TradeAmountCard/TradeAmountCard.jsx";
import PerpetualSummaryCard from "../PerpetualSummaryCard/PerpetualSummaryCard.jsx";
import { DayTool } from "../DayTool/DayTool.jsx";
import { GtdTooltip } from "../GtdTooltip/GtdTooltip.jsx";
import { LEVERAGE_PRESETS, PERPETUAL_MARGIN_MODE, PLACE_ORDER_EXECUTION } from '../placeOrder.constants';
import PlaceOrderPrimaryAction from "./PlaceOrderPrimaryAction.jsx";
import { getSubmitDecimalPlaces } from "../buySellTab.utils.jsx";
import { formatPlainDecimal } from '../placeOrder.utils';
import { PLACE_ORDER_PRICE_MAX_LENGTH } from '../buySellTab.constants';
const PlaceOrderForm = ({
  formik,
  selectedSide,
  isPerpetualMode,
  isSpotMode,
  isLimitOrder,
  marginMode,
  setMarginMode,
  leverage,
  setLeverage,
  otherCurrencyLabel,
  baseCurrencyLabel,
  buyOrderBook,
  sellOrderBook,
  handleOnChange,
  handleUpDownArrow,
  quantityEstimate,
  tpSlEnabled,
  setTpSlEnabled,
  setTakeProfitPrice,
  setStopLossPrice,
  takeProfitPrice,
  stopLossPrice,
  handleTpSlChange,
  handleTpSlUpDownArrow,
  tradeAmountResetKey,
  onGasFeeChange,
  selectedPair,
  selectedOrderType,
  setSelectedOrderType,
  setBtnActive,
  selectedDate,
  selectedTime,
  updateDateTime,
  handleExecutionTypeChange,
  formLocked = false,
  primaryActionProps
}) => <div className={`orderInputcard${formLocked ? ' orderInputcard--locked' : ''}`}>
    <form onSubmit={formik.handleSubmit}>
      <fieldset disabled={formLocked} className="orderInputcard__fieldset">
      {isPerpetualMode && <div className="perpetualControls">
          <div className="perpetualControls__row">
            <span className="perpetualControls__label">Margin Mode</span>
            <div className="perpetualControls__segmented">
              <Button type="button" className={`segmentBtn ${marginMode === PERPETUAL_MARGIN_MODE.CROSS ? 'active' : ''}`} onClick={() => setMarginMode(PERPETUAL_MARGIN_MODE.CROSS)}>
                Cross
              </Button>
              <Button type="button" className={`segmentBtn ${marginMode === PERPETUAL_MARGIN_MODE.ISOLATED ? 'active' : ''}`} onClick={() => setMarginMode(PERPETUAL_MARGIN_MODE.ISOLATED)}>
                Isolated
              </Button>
            </div>
          </div>
          <div className="perpetualControls__row perpetualControls__row--leverage">
            <div className="perpetualControls__leverageHead">
              <span className="perpetualControls__label">Leverage</span>
              <span className="perpetualControls__leverageBadge">{leverage} x</span>
            </div>
            <div className="perpetualControls__leverageSlider">
              <input type="range" min={0} max={LEVERAGE_PRESETS.length - 1} step={1} value={Math.max(LEVERAGE_PRESETS.indexOf(leverage), 0)} onChange={e => setLeverage(LEVERAGE_PRESETS[Number(e.target.value)] || 1)} aria-label="Leverage" />
              <div className="perpetualControls__leverageMarks">
                {LEVERAGE_PRESETS.map(preset => <button key={preset} type="button" className={leverage === preset ? 'active' : ''} onClick={() => setLeverage(preset)}>
                    {preset}x
                  </button>)}
              </div>
            </div>
          </div>
        </div>}

      <CustomInput id="pair_label" name="pair" type="text" placeholder={`${otherCurrencyLabel}/${baseCurrencyLabel}`} value={`${otherCurrencyLabel}/${baseCurrencyLabel}`} disabled maxLength={8} />

      {isPerpetualMode && <div className="executionTypeToggle d-flex">
          <Button type="button" className={`executionTypeBtn ${isLimitOrder ? 'active' : ''}`} onClick={() => handleExecutionTypeChange(PLACE_ORDER_EXECUTION.LIMIT)}>
            Limit
          </Button>
          <Button type="button" className={`executionTypeBtn ${!isLimitOrder ? 'active' : ''}`} onClick={() => handleExecutionTypeChange(PLACE_ORDER_EXECUTION.MARKET)}>
            Market
          </Button>
        </div>}

      <div className="currentAsk">
        <p>
          Current {selectedSide === 0 ? 'Ask' : 'Bid'}:{' '}
          <span>
            {selectedSide === 0 ? sellOrderBook.length ? sellOrderBook[sellOrderBook.length - 1].price : '' : buyOrderBook.length ? buyOrderBook[0].price : ''}
          </span>
        </p>
      </div>

      {isLimitOrder && <CustomInput label="Limit Price" id="price" name="price" type="text" onChange={handleOnChange} maxLength={PLACE_ORDER_PRICE_MAX_LENGTH} value={formik.values.price} formik={formik} disabled={formLocked}>
          <div className={`upDownarrow${formLocked ? ' upDownarrow--disabled' : ''}`}>
            <span onClick={() => !formLocked && handleUpDownArrow('+', 'price')}><UpArrowIcon /></span>
            <span onClick={() => !formLocked && handleUpDownArrow('-', 'price')}><DownArrowIcon /></span>
          </div>
        </CustomInput>}

      <div className="quantityField">
        <CustomInput label="Quantity" id="quantity" name="quantity" type="text" value={formik.values.quantity} onChange={handleOnChange} onBlur={formik.handleBlur} maxLength={PLACE_ORDER_PRICE_MAX_LENGTH} formik={formik} disabled={formLocked}>
          <div className={`upDownarrow${formLocked ? ' upDownarrow--disabled' : ''}`}>
            <span onClick={() => !formLocked && handleUpDownArrow('+', 'quantity')}><UpArrowIcon /></span>
            <span onClick={() => !formLocked && handleUpDownArrow('-', 'quantity')}><DownArrowIcon /></span>
          </div>
        </CustomInput>
        <div className="quantityField__foot">
          <span className="quantityField__estimate">
            ≈ {formatPlainDecimal(quantityEstimate)} {baseCurrencyLabel.toLowerCase()}
          </span>
        </div>
      </div>

      {isPerpetualMode && <div className="perpetualOptions">
          <Form.Check type="checkbox" id="place-order-tpsl" label="TP / SL" checked={tpSlEnabled} onChange={e => {
          if (formLocked) return;
          const enabled = e.target.checked;
          setTpSlEnabled(enabled);
          if (!enabled) {
            setTakeProfitPrice('');
            setStopLossPrice('');
          }
        }} />
        </div>}

      {isPerpetualMode && tpSlEnabled && <div className="tpSlFields">
          <CustomInput label="Take Profit" id="takeProfit" name="takeProfit" type="text" value={takeProfitPrice} onChange={handleTpSlChange} maxLength={24} placeholder="TP price" disabled={formLocked}>
            <div className={`upDownarrow${formLocked ? ' upDownarrow--disabled' : ''}`}>
              <span onClick={() => !formLocked && handleTpSlUpDownArrow('+', 'takeProfit')}><UpArrowIcon /></span>
              <span onClick={() => !formLocked && handleTpSlUpDownArrow('-', 'takeProfit')}><DownArrowIcon /></span>
            </div>
          </CustomInput>
          <CustomInput label="Stop Loss" id="stopLoss" name="stopLoss" type="text" value={stopLossPrice} onChange={handleTpSlChange} maxLength={24} placeholder="SL price" disabled={formLocked}>
            <div className={`upDownarrow${formLocked ? ' upDownarrow--disabled' : ''}`}>
              <span onClick={() => !formLocked && handleTpSlUpDownArrow('+', 'stopLoss')}><UpArrowIcon /></span>
              <span onClick={() => !formLocked && handleTpSlUpDownArrow('-', 'stopLoss')}><DownArrowIcon /></span>
            </div>
          </CustomInput>
        </div>}

      <div className="tradeAmount">
        {isSpotMode ? <TradeAmountCard side={selectedSide} formData={formik.values} resetKey={tradeAmountResetKey} onGasFeeChange={onGasFeeChange} /> : <PerpetualSummaryCard side={selectedSide} formData={formik.values} leverage={leverage} priceDecimals={getSubmitDecimalPlaces(selectedPair?.price_decimal)} quantityDecimals={getSubmitDecimalPlaces(selectedPair?.quantity_decimal)} />}
      </div>

      <div className="gtcDay">
        <Button type="button" onClick={() => setSelectedOrderType('GTC')} className={`gtcBtn ${selectedOrderType === 'GTC' ? 'active' : ''}`} disabled={formLocked}>
          GTC
        </Button>
        <DayTool setActiveBtn={setBtnActive} aciveOrderType={selectedOrderType} disabled={formLocked} />
        <GtdTooltip setActiveBtn={setBtnActive} aciveOrderType={selectedOrderType} selectedDate={selectedDate} selectedTime={selectedTime} onUpdateDateTime={updateDateTime} disabled={formLocked} />
      </div>

      {selectedOrderType === 'GTD' && <div className="dayFormat">
          <span className="dayFormat__label">Expires</span>
          <span className="dayFormat__value">
            {moment(selectedDate).isValid() ? moment(selectedDate).format('MM/DD/YYYY') : '--'}
          </span>
          <span className="dayFormat__value">
            {selectedTime ? moment(selectedTime, ['HH:mm', 'H:mm', 'h:mm A', 'hh:mm A'], true).isValid() ? moment(selectedTime, ['HH:mm', 'H:mm', 'h:mm A', 'hh:mm A'], true).format('hh:mm A') : selectedTime : '--'}
          </span>
        </div>}

      <div className="orderBtn">
        <PlaceOrderPrimaryAction {...primaryActionProps} />
      </div>
      </fieldset>
    </form>
  </div>;
export default PlaceOrderForm;